export * from './modules/common/graphql'

export const listFilters = [
  'material', 'color', 'sketch', 'hardware', 'tag', 'customAttributes', 'productComments', 'vlpProduct', 'vlpSecondaries', 'vlpVersions'
]


// WEBPACK FOOTER //
// ./src/graphql.ts